import { useState } from 'react'

 const AddTask = ({onAdd}) => {
    const [text,  setText] = useState(' ')
    const [day,  setDay] = useState(' ')
    const [reminder,  setReminder] = useState(false)

    const onSubmit = (e)  => {
        e.preventDefault()

        if(text === ' '  || day === ' ') {
            // setText(e.target.value)
            setTimeout(() => {
                setText(' ')
              }, 2000)
            setText('                    Please include a task and a day!' , 
            setTimeout(setText(' '), 20) )
            return
        
        }
        onAdd({text, day, reminder})
        setText(' ')
        setDay(' ')
        setReminder(false)
    }

  return (
      <form className="add-form Container" onSubmit={onSubmit}>
         <div className="form-control">
             <label className='task-label' >Task ❤</label>
             <input type='text' placeholder="Add Task"  value = {text} 
             onChange={(e) => setText(e.target.value)} />
             <btn ></btn>
        </div>

        <div className="form-control">
             <label className='daytime-label'>Day & Time</label>
             <input type='text' placeholder="Add Day & Time" value = {day} 
             onChange={(e) => setDay(e.target.value)} />
        </div>

        <div className='form-control form-control-check'>
             <label className="container contain-reminder">Set Reminder</label>
             <input type='checkbox'  className="check-box container"  checked={reminder} value = {reminder} 
             onChange={(e) => setReminder(e.currentTarget.checked)} />
        </div>
   {/* <input type="text" className='search' name="search" placeholder=" Search.."/> */}
        <input type='submit'  className="btn  add-btn " value= 'Save Task'></input>
        
    

    </form>
  )
}

export default AddTask
